import React, { useEffect, useState, useRef } from "react";

import {
  SearchOutlined,
  EditOutlined,
  ReloadOutlined,
  CheckOutlined,
  CloseOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import {
  PageHeader,
  Pagination,
  Input,
  Button,
  Table,
  Spin,
  Typography,
  Tag,
  List,
  InputNumber,
  Tabs,
  Modal,
  Select,
  message,
  DatePicker,
} from "antd";

import moment from "moment";

import { numberWithCommas } from "../../utils/helpers";

import ImageChecker from "../../components/Generic/ImageChecker";

import MainLocations from "../../components/analyticsTabs/MainLocations";
import Sales from "../../components/analyticsTabs/Sales";
import WastedMenu from "../../components/analyticsTabs/WastedMenu";
import WastedItems from "../../components/analyticsTabs/WastedItems";
import Inventory from "../../components/analyticsTabs/Inventory";
import { getLocations } from "../../Redux/actions/locationsActions";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import {
  loadMorePackageData,
  getAnalyticsData,
  getAnalyticsData2,
} from "../../Redux/actions/analyticsActions";
import "./styles.scss";
import "./styles.css";

const { Option } = Select;

const { TabPane } = Tabs;
const { Search } = Input;
const { RangePicker } = DatePicker;
const INITIAL_STATE = {
  searchText: "",
};

const PAGENAME = "Analytic";
const HQ_BRANCH_ID = "iVqgep3urhVOSZEd2KBH";
const HQ_BRANCH_NAME = "HQ";

const Index = (props) => {
  const [loading, setloading] = useState(false);
  const [mainSearch, setMainSearch] = useState(null);
  const [resetTable, setResetTable] = useState(false);
  //packages
  //inventory
  const [activeTab, setActiveTab] = useState("packages");
  const [loadingData, setLoadingData] = useState(false);

  const [currentSelected, setCurrentSelected] = useState([]);
  const [currentSelectedRow, setCurrentSelectedRow] = useState(null);

  const [datePickerValue, setDatePickerValue] = useState([
    moment().startOf("month"),
    moment(),
  ]);

  // const [datePickerValue, setDatePickerValue] = useState([
  //   moment("2024-01-01").startOf("day"),
  //   moment("2024-12-31").endOf("day"),
  // ]);
  const [dateFilteredPackages, setDateFilteredPackages] = useState([]);

  const tableRef = useRef();
  const dispatch = useDispatch();
  const { crudData, crudDataCount, locations, user } = useSelector(
    (state) => ({
      user: state.auth.user,
      crudData: state.analytics.data,
      crudDataCount: state.analytics.dataCount,
      locations: state.locations.locations,
    }),
    shallowEqual
  );
  const quantityOnly =
    user?.role === "warehouse" &&
    user?.branch === HQ_BRANCH_ID &&
    (!user?.branch_name || user?.branch_name === HQ_BRANCH_NAME);

  useEffect(() => {
    dispatch(getLocations());
  }, []);

  useEffect(() => {
    if (crudData.length > 0) {
      setDateFilteredPackages(crudData);
    }
  }, [crudData]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await getData();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    if (!loadingData) {
      fetchData();
    }
  }, [datePickerValue, activeTab]);

  const onSearch = (value) => {
    setMainSearch(value);
  };

  const itemSelected = (value) => {
    setCurrentSelected(value);
  };

  const rowIsSelected = (value) => {
    setCurrentSelectedRow(value);
  };

  const dateFilterPackages = (datefillvalue) => {
    var thisdates = datefillvalue;
    if (datefillvalue == null) {
      var todaydate = [moment(), moment()];
      if (crudData.length > 0) {
        var created_at = crudData[crudData.length - 1].created_at;
        todaydate[0] = moment(created_at, "YYYY-MM-DD HH:mm:ss");
      }
      thisdates = todaydate;
    }
    var minDate = thisdates[0];
    var maxDate = thisdates[1];
    setDatePickerValue(thisdates);
    // if(crudData && crudData.length > 0){
    //   var packagesFiltered = []
    //   crudData.map( thispackage =>{
    //     var datecompare = moment(thispackage.created_at, 'YYYY-MM-DD HH:mm:ss')
    //     if((datecompare > minDate && datecompare < maxDate) || datecompare.isSame(minDate, "day") || datecompare.isSame(maxDate, "day")){
    //       packagesFiltered.push(thispackage)
    //     }
    //   })
    //   setDateFilteredPackages(packagesFiltered)
    // }
  };

  const getData = async () => {
    var getprops = {};
    if (!loadingData) {
      setLoadingData(true);
      switch (activeTab) {
        case "packages":
          getprops = {
            apiurl: "packages",
            start_date: moment(datePickerValue[0])
              .startOf("date")
              .format("YYYY-MM-DD HH:mm:ss"),
            end_date: moment(datePickerValue[1])
              .endOf("date")
              .format("YYYY-MM-DD HH:mm:ss"),
            packageStatus: "completed",
          };
          await dispatch(getAnalyticsData2(getprops));
          break;

        case "sales":
          getprops = {
            apiurl: "sales",
            start_date: moment(datePickerValue[0])
              .startOf("date")
              .format("YYYY-MM-DD HH:mm:ss"),
            end_date: moment(datePickerValue[1])
              .endOf("date")
              .format("YYYY-MM-DD HH:mm:ss"),
            packageStatus: "completed",
            use_sale_date: true,
          };
          await dispatch(getAnalyticsData2(getprops));
          break;

        case "wastedmenu":
          getprops = {
            apiurl: "wastedmenu",
            start_date: moment(datePickerValue[0])
              .startOf("date")
              .format("YYYY-MM-DD HH:mm:ss"),
            end_date: moment(datePickerValue[1])
              .endOf("date")
              .format("YYYY-MM-DD HH:mm:ss"),
            packageStatus: "completed",
            use_wasted_date: true,
          };
          await dispatch(getAnalyticsData2(getprops));
          break;

        case "wasteditems":
          getprops = {
            apiurl: "wastes",
            start_date: moment(datePickerValue[0])
              .startOf("date")
              .format("YYYY-MM-DD HH:mm:ss"),
            end_date: moment(datePickerValue[1])
              .endOf("date")
              .format("YYYY-MM-DD HH:mm:ss"),
            packageStatus: "completed",
          };
          await dispatch(getAnalyticsData2(getprops));
          break;

        default:
        // code block
      }
      setLoadingData(false);
    }
  };

  const renderTable = () => {
    switch (activeTab) {
      case "packages":
        return (
          <MainLocations
            maindata={dateFilteredPackages}
            datePickerValue={datePickerValue}
            hideMoney={quantityOnly}
          />
        );
      case "sales":
        return (
          <Sales
            maindata={dateFilteredPackages}
            datePickerValue={datePickerValue}
            hideMoney={quantityOnly}
          />
        );
      case "wastedmenu":
        return (
          <WastedMenu
            maindata={dateFilteredPackages}
            datePickerValue={datePickerValue}
          />
        );
      case "wasteditems":
        return (
          <WastedItems
            maindata={dateFilteredPackages}
            datePickerValue={datePickerValue}
            hideMoney={quantityOnly}
          />
        );
      case "inventory":
        return (
          <Inventory
            maindata={dateFilteredPackages}
            datePickerValue={datePickerValue}
            hideMoney={quantityOnly}
          />
        );

      default:
      // code block
    }
  };

  return (
    <>
      <div className="maindiv">
        <div className={"generic_container"}>
          {(function () {
            var originalAddEventListener =
              EventTarget.prototype.addEventListener;

            EventTarget.prototype.addEventListener = function (
              type,
              listener,
              options
            ) {
              // Define the event types for which you want to use passive listeners
              var passiveEvents = [
                "touchstart",
                "touchmove",
                "wheel",
                "mousewheel",
              ];

              // Check if the current event type is in the list of passive events
              if (passiveEvents.indexOf(type) > -1) {
                // Set the passive option to true if it's not already specified
                var newOptions =
                  typeof options === "boolean"
                    ? { capture: options, passive: true }
                    : Object.assign({}, options, { passive: true });
                originalAddEventListener.call(this, type, listener, newOptions);
              } else {
                // For other events, use the options as provided
                originalAddEventListener.call(this, type, listener, options);
              }
            };
          })()}
          <PageHeader
            title={PAGENAME + "s"}
            subTitle={
              <div className={"header"}>
                {/* <Search placeholder="input search text" allowClear={true} onChange={(e)=>{if(!e.target.value &&mainSearch){onSearch(null)}}} onSearch={onSearch} enterButton />  */}
              </div>
            }
            extra={
              <div className={"header"}>
                {loadingData ? <Spin size={"small"} tip="Loading..." /> : null}
                <RangePicker
                  loading={loadingData}
                  value={datePickerValue}
                  onCalendarChange={(e) => {
                    dateFilterPackages(e);
                  }}
                />
                <div className="ordercount_lastdatetest">
                  <span>
                    oldest item loaded:{" "}
                    {crudData
                      ? crudData[crudData.length - 1]
                        ? crudData[crudData.length - 1].created_at
                        : null
                      : null}{" "}
                  </span>
                  <div className="spaceout">
                    <span>filtered: {dateFilteredPackages.length} </span>
                    <span>loaded: {crudData.length} </span>
                  </div>
                </div>
                <Button
                  onClick={() => {
                    getData();
                  }}
                  className="button"
                >
                  <ReloadOutlined />
                </Button>
              </div>
            }
          >
            <Tabs
              activeKey={activeTab}
              onChange={(e) => {
                setActiveTab(e);
              }}
            >
              <TabPane tab="Packages" key={"packages"} />
              <TabPane tab="Sales" key={"sales"} />
              <TabPane tab="Wasted Menu" key={"wastedmenu"} />
              <TabPane tab="Wasted Items" key={"wasteditems"} />
              <TabPane tab="Inventory" key={"inventory"} />
            </Tabs>
          </PageHeader>
          <div className={"content_container"}>{renderTable()}</div>
        </div>
      </div>
    </>
  );
};

export default Index;
